import { SceneTemplate } from "@/lib/utils/lomda/types";

export const templateF: SceneTemplate = {
    name: "תבנית ו",
    aspectRatio: "1:1.414",
    branding: {
        background: "primary",
        foreground: {
            color: "secondary",
            rounded: true,
            size: {
                width: 45,
                height: 82,
            },
            location: {
                x: 46,
                y: 9,
            },
        },
    },
    avatar: {
        nested: true,
        size: {
            width: 100,
            height: 100,
        },
        location: {
            x: 0,
            y: 0,
        },
    },
    scene: {
        scale: 82,
        rounded: true,
        location: {
            x: 9,
            y: 9,
        },
    },
};
